'use client';

import dynamic from 'next/dynamic';
import { usePathname } from 'next/navigation';

import type { ReactNode } from 'react';

const ChatbotLazyMount = dynamic(() => import('./ChatbotLazyMount').then((mod) => mod.ChatbotLazyMount), {
  ssr: false,
  loading: () => null
});

type Props = {
  children: ReactNode;
};

// Paths where chatbot should be excluded
const CHATBOT_EXCLUDED_PATHS = ['/journey-guide/', '/partner-banner-embed', '/map'] as const;

export function ChatbotAndLayoutWrapper({ children }: Props) {
  const pathname = usePathname();

  const showIntercomChatbot = process.env.NEXT_PUBLIC_ENABLE_INTERCOM_CHATBOT === 'true';

  const isChatbotEnabled = process.env.NEXT_PUBLIC_FF_ENABLE_CHATBOT === 'true';
  const isPathExcluded = pathname
    ? CHATBOT_EXCLUDED_PATHS.some((excludedPath) => pathname.includes(excludedPath))
    : true;

  const showChatbot = isChatbotEnabled && !isPathExcluded;

  return (
    <>
      {children}
      {showChatbot && !showIntercomChatbot && <ChatbotLazyMount />}
    </>
  );
}
